import React from "react";
import {
    Box,
    Typography,
    Chip,
} from "@mui/material";

import default_theme from "assets/themes/themes";

const DraftStatusSection = ({
    status = "Draft",
}) => {
    return (
        <Box sx={{ mt: 3 }}>
            <Typography
                variant="h6"
                sx={{
                    fontWeight: "bold",
                    color: default_theme.palette.other.addButtonBlue,
                }}
            >
                Status
            </Typography>

            <Box sx={{ mt: 1.5 }}>
                <Chip
                    label={status}
                    size="small"
                    sx={{
                        backgroundColor:
                            default_theme.palette.other.paleGreen,
                    }}
                />
            </Box>
        </Box>
    );
};

export default DraftStatusSection;